
import {
  SET_SELECTED_STATS,
  RESET_SELECTED_STATS,
  TOGGLE_SELECTED_STATS_VISIBILITY
} from './types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_SELECTED_STATS:
      return action.statFilters;
    case RESET_SELECTED_STATS:
      return null;
    case TOGGLE_SELECTED_STATS_VISIBILITY:
      return { ...state,
        [action.statsName]: { ...state[action.statsName], isVisible: !state[action.statsName].isVisible }
      };
    default:
      return state;
  }
};
